import types from './mutations-types';
import api from './api';

export default {
	async getPlants_({ commit }) {
		let data = await api.getPlants();
		let options = [];
		if (data.body) {
			data.body.map(v => {
				if (v.commCdName !== 'PLANT') {
					options.push({ text: v.commCdName, value: v.commCd });
				}
			});
		}

		commit(types.DEFAULT_ASSIGN, {
			key: 'plants',
			value: options
		});
		commit(types.DEFAULT_ASSIGN, {
			key: 'plantCd',
			value: data.body.length > 0 ? data.body[0].commCd : ''
		});

		return data.header;
	},
	async getUserConnHistory_({ commit }, { searchParams, currentPage, pageUnit }) {
		let data = await api.getUserConnHistory({ searchParams, currentPage, pageUnit });
		let header = data.header;

		// if (header.code === 200 || header.code === 404) {
		// 	let body = data.body.resultList;

		// 	body.map((object, index) => {
		// 		object.test = index;
		// 	});
		// 	commit(types.DEFAULT_ASSIGN, {
		// 		key: 'resultList',
		// 		value: body
		// 	});
		// 	commit(types.DEFAULT_ASSIGN, {
		// 		key: 'searchMonth',
		// 		value: searchParams.searchMonth
		// 	});
		// } else {
		// 	console.log('오류 발생');
		// }

		if (header.code === 0) {
			let body = data.body.resultList;

			body.map((object, index) => {
				object.test = index;
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'resultList',
				value: body
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'groups',
				value: data.body.pagingInfo
			});
			commit(types.DEFAULT_ASSIGN, {
				key: 'searchMonth',
				value: searchParams.searchMonth
			});
		} else if (header.code === 1) {
		} else if (header.code === 2) {
		} else if (header.code === 3) {
		} else if (header.code === 4) {
		} else if (header.code === 5) {
		}

		return data.header;
	}
};
